module.exports = __webpack_public_path__ + "img/beihang_university.6627e42c.png";